import React, { useEffect, useState } from "react";
import { adminInstance } from '../services/axiosInstance'; 
import { Table, Button, Form } from "react-bootstrap";
import { useParams } from "react-router-dom";

const ProductImagePage = () => {
  const { subGroupId } = useParams();
  const [subgroup, setSubgroup] = useState(null);
  const [selectedFiles, setSelectedFiles] = useState({});
  
  useEffect(() => {
    fetchSubGroup();
  }, []);

  const fetchSubGroup = async () => {
    try {
      const response = await adminInstance.get(`subgroup/GetSubGroupById/${subGroupId}`);
      setSubgroup(response.data.subGroup);
    } catch (error) {
      console.error("Error fetching data", error);
    }
  };

  // Store selected file in state but don't upload yet
  const handleFileChange = (e, property) => {
    setSelectedFiles({ ...selectedFiles, [property]: e.target.files[0] });
  };

  const handleFileUpload = async (property) => {
    debugger; 
    const file = selectedFiles[property];
    if (!file) return;

    var formData = new FormData();
    formData.append("file", file);

    for (let pair of formData.entries()) {
      console.log(pair[0] + ':', pair[1]);
    }

    try {
        await adminInstance.post(`subgroup/upload/${subGroupId}/${property}`, formData, {
        headers: { "Content-Type": "multipart/form-data" },
      });
      alert("File uploaded successfully!");
      fetchSubGroup(); // Refresh the data after upload
      setSelectedFiles({ ...selectedFiles, [property]: null }); 
    } catch (error) {
      console.error("Upload error", error);
      alert("Upload failed.");
    }
  };

  const handleDelete = async (property) => {
    try {
        await adminInstance.delete(`subgroup/delete/${subGroupId}/${property}`);
      fetchSubGroup();
      alert("File deleted successfully!");
    } catch (error) {
      console.error("Delete error", error);
    }
  };

  if (!subgroup) return <p>Loading...</p>;

  return (
    <div className="card aon-card">
        <div className="card-header aon-card-header">
            <h4>
                Product Image Manager
            </h4>
        </div>
        <div className="card-body aon-card-body">
          <div className="container">
            <h2>{subgroup.SubGroupName} | {subgroup.SubGroupCode}</h2>
            <Table bordered>
              <thead>
                <tr>
                  <th>Type</th>
                  <th>File</th>
                  <th>Upload</th>
                  <th>Delete</th>
                </tr>
              </thead>
              <tbody>
                {["Img", "Img1", "Img2", "Img3"].map((property) => (
                  <tr key={property}>
                    <td>{property}</td>
                    <td>
                      {subgroup[property] ? (
                        property.startsWith("Img") ? (
                          <img
                            src={`${subgroup[property]}`}
                            alt={property}
                            width="100"
                          />
                        ) : (
                          <a href={`${subgroup[property]}`} download>
                            {subgroup[property]}
                          </a>
                        )
                      ) : (
                        "No file"
                      )}
                    </td>
                    <td>
                      <Form.Control type="file" onChange={(e) => handleFileChange(e, property)} />
                    </td>
                    <td>
                      <Button variant="primary" onClick={() => handleFileUpload(property)}>
                        Upload
                      </Button>
                      {subgroup[property] && <Button variant="danger" onClick={() => handleDelete(property)}>Delete</Button>}
                    </td>
                  </tr>
                ))}
              </tbody>
            </Table>
          </div>
      </div>
    </div>
  );
};

export default ProductImagePage;
